'use strict';

// We change the sign to negative because of
// http://www.w3schools.com/jsref/jsref_gettimezoneoffset.asp
// For example, If your time zone is GMT+2, -120 will be returned.
Cookies.set('timezoneOffset', -new Date().getTimezoneOffset(), { path: '/' });


